import * as React from 'react';
import { Base as BaseField } from './Base';
import { FieldProps, FieldRenderProps } from 'react-final-form';
import { ComponentProps } from 'react';
import { DeepPartial } from '../../common/props';
import { FieldValidator } from 'final-form';

type OriginBaseProps<VAL = any> = Omit<
  ComponentProps<typeof BaseField>,
  keyof FieldProps<VAL, FieldRenderProps<VAL, HTMLElement>>
> &
  DeepPartial<
    Omit<
      FieldProps<VAL, FieldRenderProps<VAL, HTMLElement>, HTMLElement>,
      'component'
    >
  > & {
    name: string;
    input: React.ComponentType<FieldRenderProps<VAL, HTMLElement>>;
    label: React.ReactNode;
    validateWarning?: FieldValidator<any>;
  };

export const Base = React.memo((props: OriginBaseProps<{}>) => (
  <BaseField {...props} />
));

export { Wysiwyg } from './Wysiwyg';
export { String } from './String';
export { Email } from './Email';
export { Phone } from './Phone';
export { File } from './File';
export { MultiFile } from './MultiFile';
export { Number } from './Number';
export { Radio } from './Radio';
export { RadioGroup } from './RadioGroup';
export { SelectBox } from './SelectBox';
export { SelectBoxSuggestText } from './SelectBoxSuggestText';
export { ColorSelect } from './ColorSelect';
export { Autocomplete } from './Autocomplete';
export { AutocompleteSuggestText } from './AutocompleteSuggestText';
export { TextArea } from './TextArea';
export { Detail } from './Detail';
export { DetailComponent } from './DetailComponent';
export { Date } from './Date';
export { DateTime } from './DateTime';
export { Time } from './Time';
export { DayMonth } from './DayMonth';
export { Duration } from './Duration';
export { Month } from './Month';
export { Checkbox } from './Checkbox';
export { MultiSelect } from './MultiSelect';
export { ImageGallery } from './ImageGallery';
export { ApiMultiSelect } from './ApiMultiSelect';
export { Slider } from './Slider';
export { RangeSlider } from './RangeSlider';
export { Password } from './Password';
export { Switch } from './Switch';

// export { Checkbox } from './Checkbox';
// export { DateTime as DateTime } from './DateTime';
// export { TimePicker } from './TimePicker';
// export { Autocomplete } from './Autocomplete';
// export { ApiAutocomplete } from './ApiAutocomplete';
// export { MultiSelectField as MultiSelectFilter } from './MultiSelectField';
// export { DateRange } from './DateRange';
// export { Number } from './Number';
// export { TextArea } from './TextArea';
// export { CurrencyNumber } from './CurrencyNumber';
